import { SalesOrderNote } from "../types";

const formatSalesOrderNotes = (salesOrderNotes: SalesOrderNote[]) => {
	// Extract and reverse the sales order notes for chronological order
	const salesOrderNotesChronologicalOrder =
		salesOrderNotes?.slice().reverse() || [];

	// Filter notes to get only admin-related notes
	const adminNotes = salesOrderNotesChronologicalOrder?.filter(
		(note: any) => note?.salesOrderNoteType?.slug === "admin"
	);

	const contractorInfo = salesOrderNotes?.find(
		(note: { [key: string]: any }) => {
			return note.salesOrderNoteType?.name === "Contractor Duration";
		}
	);

	// Extract and sort notes related to the "Request Reason" type
	const reasonForRequest =
		salesOrderNotesChronologicalOrder
			?.filter(
				(note: any) =>
					note?.salesOrderNoteType?.name === "Request Reason"
			)
			.sort(
				(noteA: any, noteB: any) =>
					new Date(noteB.dtStamp).getTime() -
					new Date(noteA.dtStamp).getTime()
			)?.[0]?.note ?? null; // sort by date to get most recent // Get the most recent note or null

	// Extract and sort notes related to "Shipping Instructions"
	const shippingInstructions =
		salesOrderNotesChronologicalOrder
			?.filter(
				(note: any) =>
					note?.salesOrderNoteType?.name === "Shipping Instructions"
			)
			.sort(
				(noteA: any, noteB: any) =>
					new Date(noteB.dtStamp).getTime() -
					new Date(noteA.dtStamp).getTime()
			)?.[0]?.note ?? null; // Get the most recent note or null

	return {
		salesOrderNotes: salesOrderNotesChronologicalOrder || [],
		adminNotes: adminNotes || [],
		reasonForRequest: reasonForRequest,
		shippingInstructions: shippingInstructions,
		contractorInfo: contractorInfo || null,
	};
};

export default formatSalesOrderNotes;
